import api from './api';
import { AuthResponse, User } from '../types';

export const authService = {
    // Register new user
    register: async (userData: {
        email: string;
        password: string;
        first_name: string;
        last_name: string;
        phone?: string;
        company_name?: string;
        account_type: 'professional' | 'individual';
    }): Promise<AuthResponse> => {
        const response = await api.post('/auth/register', userData);
        return response.data;
    },

    // Login user
    login: async (credentials: {
        email: string;
        password: string;
    }): Promise<AuthResponse> => {
        const response = await api.post('/auth/login', credentials);
        return response.data;
    },

    // Get current user
    getCurrentUser: async (): Promise<{ user: User }> => {
        const response = await api.get('/auth/me');
        return response.data;
    },

    // Update user profile
    updateProfile: async (profileData: {
        first_name?: string;
        last_name?: string;
        phone?: string;
    }): Promise<{ message: string }> => {
        const response = await api.put('/auth/profile', profileData);
        return response.data;
    },

    // Logout (client-side)
    logout: () => {
        localStorage.removeItem('eldai_token');
        localStorage.removeItem('eldai_user');
    },

    // Check if user is authenticated
    isAuthenticated: (): boolean => {
        const token = localStorage.getItem('eldai_token');
        return !!token;
    },

    // Get stored user
    getStoredUser: (): User | null => {
        const userStr = localStorage.getItem('eldai_user');
        return userStr ? JSON.parse(userStr) : null;
    },

    // Store auth data
    storeAuthData: (token: string, user: User) => {
        localStorage.setItem('eldai_token', token);
        localStorage.setItem('eldai_user', JSON.stringify(user));
    },

    // Admin functions for user approval
    getPendingRegistrations: async (): Promise<{ pendingUsers: any[] }> => {
        const response = await api.get('/auth/pending-registrations');
        return response.data;
    },

    approveRegistration: async (userId: number): Promise<{ message: string }> => {
        const response = await api.post(`/auth/approve-registration/${userId}`);
        return response.data;
    },

    rejectRegistration: async (userId: number, reason?: string): Promise<{ message: string }> => {
        const response = await api.post(`/auth/reject-registration/${userId}`, { reason });
        return response.data;
    },
};
